import { TeamMemberCapacityResponse } from '@/modules/team/types/dto/response/team-member-capacity-response';
import { TeamMember } from '@/modules/team/types/team-member';

/**
 * Maps team member capacity response to domain model fields
 * Converts minutes to hours and calculates corporate function capacity
 */
export const mapTeamMemberCapacityFromResponse = (
  response: TeamMemberCapacityResponse
): Partial<TeamMember> => {
  // Convert total working minutes to hours for capacityPerDay
  const capacityPerDay = response.totalWorkingMinutes ? response.totalWorkingMinutes / 60 : 0;

  // Calculate corporate function capacity (100 - billable)
  const billableCapacity = response.billableCapacity || 0;
  const corporateFunctionCapacity = 100 - billableCapacity;

  return {
    isOnDemandAvailability: response.onDemand,
    capacityPerDay,
    billableCapacity,
    corporateFunctionCapacity,
  };
};
